import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as Sentry from '@sentry/browser'
import { Nav, Navbar, NavItem } from 'react-bootstrap'

import { guessVars } from '../../actions/states/new/setupVars'
import { browserHistory } from '../../Routes'

class FeatureWrap extends React.PureComponent {
  constructor(props) {
    super(props)
    this.contactFormRef = null
    this.state = {
      siteVars: {}
    }
  }

  componentDidMount() {
    console.log(this.props)
    const siteVars = guessVars(this.props.match.params.state)

    console.log(siteVars)
    this.setState({ ...this.state, siteVars })
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      this.props.match.params.state != nextProps.match.params.state &&
      nextProps.match.params.state !== '..' &&
      nextProps.match.params.state !== '.'
    ) {
      const siteVars = guessVars(nextProps.match.params.state)

      this.setState({ ...this.state, siteVars })
    }
  }

  genBgColor = path => {
    switch (path) {
      case 'localopportunities':
        return '#FF8300'
      case 'plan':
        return '#1DA7E0'
      case 'uptheladder':
        return '#D7282F'
      case 'about':
        return '#80BC00'
      default:
        return '#cccccc'
    }
  }

  findLogo = () => {
    switch ((this.props.statePrefix || '').toLowerCase()) {
      case 'ca':
        return `/images/california/new/logo/H2-CZZ-CareerExplorer-Logo-0718-v1.13_main.svg`
      case 'ar':
        return `/images/arkansas/logo/logo/Main/H2-CareerExplorer-Logo-Arkansas-1118-v1_MainDark.svg`
      case 'pa':
        return `/images/pennsylvania/new/logo/Main/Dark/H2-Pennsylvania-logo-LogoPack-0817_MainDark.svg`
      case 'nv':
        return `/images/nevada/logo/Logo/Dark/Main/H2-NevadaCareerExplorer-Logo-0119_MainDark.svg`
      default:
        return `/images/headed2/logo.svg`
    }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
  }

  makeLink = path => {
    if (this.state.siteVars) {
      return `${this.state.siteVars.pathPrefix}${path}`
    }

    return path
  }

  render() {
    const props = this.props
    // const model = 'forms.arkansasForm'
    const { children } = props

    const linkStyle = {
      color: 'white'
    };

    const spanStyle = {
      color: 'green',
      lineHeight: '50px'
    };

    let path = window.location.pathname

    if (this.props.params && this.props.match.params.state) {
      path = path.slice(this.props.match.params.state.length + 2)
    } else {
      path = path.slice(1)
    }

    //const browserHistory = useHistory();
    console.log(props)

    return (
      <div className="feature-section">
        <Navbar collapseOnSelect={true} fixedTop>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to={this.makeLink('/')}>
                <img
                  src={this.state.siteVars.logoImg}
                  style={{ height: '40px' }}
                  alt="Headed2 Logo"
                />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav style={{ marginTop: '10px' }}>
              <p>{this.state.siteVars.menuHeader}</p>
              <NavItem
                eventKey={1}
                className={`menuitem yourplan ${path === 'plan' ? 'active' : ''}`}
                onClick={e => {
                  e.preventDefault()
                  browserHistory.push(this.makeLink('/plan'))
                }}
                href={this.makeLink('/plan')}>
                Career Exploration
              </NavItem>
              <NavItem
                eventKey={2}
                className={`localopportunities menuitem ${
                  path === 'localopportunities' ? 'active' : ''
                }`}
                onClick={e => {
                  e.preventDefault()
                  browserHistory.push(this.makeLink('/localopportunities'))
                }}
                href={this.makeLink('/localopportunities')}>
                Work Based Learning
              </NavItem>
              <NavItem
                eventKey={3}
                className={`uptheladder menuitem ${
                  path === 'uptheladder' ? 'active' : ''
                }`}
                onClick={e => {
                  e.preventDefault()
                  browserHistory.push(this.makeLink('/uptheladder'))
                }}
                href={this.makeLink('/uptheladder')}>
                Early Learners
              </NavItem>
            </Nav>
            <Nav pullRight>
              <NavItem eventKey={4}>
                <button
                  onClick={() => {
                    browserHistory.push(this.makeLink('/pricing'))
                  }}
                  className="btn btn-success btn-lg navbar-btn">
                  Get Pricing
                </button>
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <div
          style={{ minHeight: '50vh', marginTop: '100px' }}
          id={`main-wrap-${this.state.siteVars.siteId}`}>
          {children}
        </div>

        <div style={{ backgroundColor: '#000', minHeight: '50px' }}>
          <div className="container">
          <a
              href="/privacy"
              style={linkStyle}>
              <span style={spanStyle}>
                Privacy Statement
              </span>
            </a>

            <span style={{ color: 'white', display: 'block' }}>
              Copyright {new Date().getFullYear()},{' '}
              <a
                style={{ color: 'white' }}
                href="https://www.powerschool.com/privacy-statement-overview/">
                PowerSchool Group LLC
              </a>
            </span>
            <div className="social">
              <ul>
                <li>
                  <a
                    href="https://www.linkedin.com/company/headed2"
                    target="_blank"
                    rel="noreferrer">
                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UC26RWFyXhS6jFaaIhVrDHpg"
                    target="_blank"
                    rel="noreferrer">
                    <i className="fa fa-youtube" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/headed2/"
                    target="_blank"
                    rel="noreferrer">
                    <i className="fa fa-facebook" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/headed2careers"
                    target="_blank"
                    rel="noreferrer">
                    <i className="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      formRequest: state.forms.formRequest
    }
  },
  dispatch => {
    return { dispatch }
  }
)(withRouter(FeatureWrap))
